"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Dropdownlist;

require("core-js/modules/es.regexp.to-string.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.array.includes.js");

require("core-js/modules/es.string.includes.js");

var _react = require("react");

var _useOnClickOutside = _interopRequireDefault(require("../../hooks/useOnClickOutside"));

var _DropdownlistModule = _interopRequireDefault(require("../../assets/styles/components/Dropdownlist.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import styles from "../../assets/styles/components/Dropdownlist.module.scss";
// import input_styles from "../../assets/styles/components/Input.module.scss";
// import { useState, useRef, MutableRefObject, useEffect } from "react";
// import Input from "./Input";
// import useOnClickOutside from "../../hooks/useOnClickOutside";
// import useEffectAll from "../../hooks/useEffectAll";
// type Props = {
//     onSelect: (object:{value:string; label:string}) => void;
//     options: Array<string>
//     selected: string;
//     direction?: "top" | "bottom";
//     size?: "mini" | "compact" | "default" | "large";
//     placeholder?: string;
//     positive?: boolean;
//     error?: boolean;
//     disabled?: boolean;
//     readOnly?: boolean;
//     isClearable?: boolean;
//     removeDuplicates?: boolean;
//     closeOnSelect?: boolean;
//     scrollTo?: boolean;
//     styling?: object;
//     type?: "ID_LABEL";
//     uniqueId?: string
// }
// const Dropdownlist : React.FC<Props> = ({options, selected, onSelect, direction="bottom", styling, size="default", scrollTo, error, positive, placeholder="Select...", closeOnSelect, disabled, readOnly, isClearable, removeDuplicates, type="ID_LABEL", uniqueId=Array.from({length: 10}, () => Math.random().toString(36)[2]).join('')}) => {
//     const inputRef = useRef() as MutableRefObject<HTMLInputElement>;
//     const menuRef = useRef() as MutableRefObject<HTMLDivElement>
//     const dropdownRef = useRef() as MutableRefObject<HTMLDivElement>;
//     const [filtered_options, setfiltered_options] = useState<Array<{value:string; label:string;}>>();
//     const [selected_option, setselected_option] = useState<string>("");
//     const [show_dropdown, setshow_dropdown] = useState(false);
//     useOnClickOutside(dropdownRef, () => {if(show_dropdown){setshow_dropdown(false)}})
//     useEffect(()=>{
//         setOptions()
//     }, [options])
//     useEffect(()=>{
//         if(selected.split("_")[1]){
//             setselected_option(selected);
//             inputRef.current.value = selected.split("_")[1]
//         }
//     }, [selected])
//     useEffect(()=>{
//         if(scrollTo && selected !== "" && menuRef.current){
//             let item = selected;
//             if(selected_option !== ""){
//                 item = selected_option
//             }
//             let element = document.getElementById(uniqueId+"_"+item);
//             if(element){
//                 element.scrollIntoView({block: 'nearest'})
//             }
//         }
//     }, [scrollTo, selected, selected_option, menuRef, show_dropdown])
//     const setOptions = () => {
//         if(type === "ID_LABEL"){
//             let a:Array<{value:string; label:string;}> = []
//             let tmp_options = [...options]
//             tmp_options.forEach(option => {
//                 if(option.includes("_")){
//                     let value = option.split("_")[0]
//                     let label = option.split("_")[1]
//                     if(removeDuplicates){
//                         const i = a.findIndex(item => item.value === value);
//                         if(i < 0){
//                             a.push({value:value, label: label})
//                         }
//                     }
//                     else {
//                         a.push({value:value, label: label})
//                     }
//                 }
//             });
//             setfiltered_options(a)
//         }
//     }
//     const clearSelection = () => {
//         inputRef.current.value = "";
//         setshow_dropdown(false)
//         onSelect({value:"", label:""})
//     }
//     const searchOption = (value:string) => {
//         let tmp_options = [...options]
//         let a:Array<{value:string; label:string;}> = []
//         tmp_options.forEach(option => {
//             if(option.toLowerCase().includes(value.toLowerCase())){
//                 let value = option.split("_")[0]
//                 let label = option.split("_")[1]
//                 if(removeDuplicates){
//                     const i = a.findIndex(item => item.value === value);
//                     if(i < 0){
//                         a.push({value:value, label: label})
//                     }
//                 }
//                 else {
//                     a.push({value:value, label: label})
//                 }
//             }
//         });
//         setfiltered_options(a)
//     }
//     const pickOption = (option:{value:string; label:string}) => {
//         onSelect(option);
//         setselected_option(option.value+"_"+option.label);
//         inputRef.current.value = option.label;
//         if(closeOnSelect){
//             setshow_dropdown(false);
//         }
//     }
//     const blurInputfield = () => {
//         if(selected_option.includes("_")){
//             inputRef.current.value = selected_option.split("_")[1]
//         }
//     }
//     return (
//         <div ref={dropdownRef} className={styles.dropdownlist}>
//             <div className={`${styles.input} ${input_styles.input}`}>
//                 <div
//                 className={`
//                 ${input_styles.inputfield}
//                 ${size === "mini" ? input_styles.inputfield_size_mini : size === "compact" ? input_styles.inputfield_size_compact : size === "default" ? input_styles.inputfield_size_default : input_styles.inputfield_size_large}
//                 ${error && input_styles.inputfield_error}
//                 ${positive && input_styles.inputfield_positive}
//                 `}
//                 style={styling}
//             >
//                 <input onBlur={()=>{blurInputfield()}} onChange={(e:React.ChangeEvent<HTMLInputElement>)=>{searchOption(e.target.value)}} onFocus={()=>{setshow_dropdown(true)}} ref={inputRef} className={input_styles.input} type="text" placeholder={placeholder} disabled={disabled} readOnly={readOnly}/>
//                 {isClearable && 
//                 <button disabled={disabled} onClick={()=>{clearSelection()}} className={styles.button_open}>
//                     <svg className={styles.icon} viewBox="0 0 24 24" width="16" height="16" stroke="black" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
//                 </button>
//                 }
//                 <button disabled={disabled} onClick={()=>{inputRef.current.focus()}} className={styles.button_open}>
//                     <svg className={styles.icon} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>
//                 </button>
//             </div>
//             </div>
//             <div ref={menuRef} className={`${!show_dropdown && styles.menu_hidden} ${direction === "top" && styles.menu_top} ${styles.menu}`} style={show_dropdown ? {visibility:"visible", opacity:1} : {visibility:"hidden", opacity:0}}>
//                 {
//                 filtered_options &&
//                     filtered_options.length > 0 ?
//                         filtered_options.map((option, index)=>{
//                             return (
//                                 <button id={uniqueId+"_"+option.value+"_"+option.label} onClick={()=>{pickOption(option)}} value={option.value} className={styles.option} key={index}>{option.label}</button>
//                             )
//                         })
//                     :
//                     <button className={styles.option}>Geen opties gevonden</button>   
//                 }
//             </div>
//         </div>
//     )
// }
// export default Dropdownlist;
function Dropdownlist(_ref) {
  let {
    isClearable,
    closeOnSelect,
    error,
    direction = "bottom",
    size = "default",
    disabled,
    removeDuplicates,
    options,
    selected,
    placeholder = "Select...",
    onSelect,
    type,
    readOnly = false,
    scrollTo,
    uniqueId = Array.from({
      length: 10
    }, () => Math.random().toString(36)[2]).join('')
  } = _ref;
  const [selectedOption, setselectedOption] = (0, _react.useState)("");
  const [filteredOptions, setfilteredOptions] = (0, _react.useState)([]);
  const [showDropdown, setshowDropdown] = (0, _react.useState)(false);
  const refList = (0, _react.useRef)();
  (0, _react.useEffect)(() => {
    if (Array.isArray(options)) {
      calculateOptions();
    }
  }, [options]);
  (0, _react.useEffect)(() => {
    if (typeof selected === "string") {
      calculateSelectedOption();
    }
  }, [selected]);
  (0, _react.useEffect)(() => {
    if (scrollTo && refList.current && selected) {
      let element = document.getElementById(uniqueId + "_" + selected);

      if (element) {
        element.scrollIntoView({
          block: 'nearest'
        });
      }
    }
  }, [scrollTo, refList, selected, uniqueId]);

  const calculateSelectedOption = () => {
    if (Array.isArray(options)) {
      if (options.includes(selected)) {
        inputRef.current.value = selected.split("_")[1];
        setselectedOption(selected);
      } else if (selected === "") {
        setselectedOption(selected);
        inputRef.current.value = selected;
      }
    }
  };

  const calculateOptions = () => {
    if (type === "ID_LABEL") {
      let a = [];
      let tmp_options = [...options];

      for (let i = 0; i < tmp_options.length; i++) {
        tmp_options[i] = tmp_options[i].toString();

        if (tmp_options[i].split("_")[1]) {
          if (removeDuplicates) {
            const ind = a.findIndex(item => item.value === tmp_options[i].split("_")[0]);

            if (ind === -1) {
              a.push({
                value: tmp_options[i].split("_")[0],
                label: tmp_options[i].split("_")[1]
              });
            }
          } else {
            a.push({
              value: tmp_options[i].split("_")[0],
              label: tmp_options[i].split("_")[1]
            });
          }
        }
      }

      setfilteredOptions(a);
    }
  };

  const searchValues = value => {
    let tmp_options = [...options];
    let a = [];

    for (let i = 0; i < tmp_options.length; i++) {
      if (tmp_options[i].toString().toLowerCase().includes(value.toLowerCase())) {
        if (tmp_options[i].split("_")[1]) {
          if (removeDuplicates) {
            const ind = a.findIndex(item => item.value === tmp_options[i].split("_")[0]);

            if (ind === -1) {
              a.push({
                value: tmp_options[i].split("_")[0],
                label: tmp_options[i].split("_")[1]
              });
            }
          } else {
            a.push({
              value: tmp_options[i].split("_")[0],
              label: tmp_options[i].split("_")[1]
            });
          }
        }
      }
    }

    setfilteredOptions(a);
  };

  const inputRef = (0, _react.useRef)(null);

  const selectValue = value => {
    if (isClearable) {
      if (value === "") {
        onSelect(value);
        setselectedOption("");
        return;
      }
    }

    onSelect(value);

    if (closeOnSelect) {
      setshowDropdown(false);
    }

    const val = value.value + "_" + value.label;
    let a = [];
    let tmp_options = [...options];

    for (let i = 0; i < tmp_options.length; i++) {
      tmp_options[i] = tmp_options[i].toString();

      if (tmp_options[i].split("_")[1]) {
        if (removeDuplicates) {
          const ind = a.findIndex(item => item.value === tmp_options[i].split("_")[0]);

          if (ind === -1) {
            a.push({
              value: tmp_options[i].split("_")[0],
              label: tmp_options[i].split("_")[1]
            });
          }
        } else {
          a.push({
            value: tmp_options[i].split("_")[0],
            label: tmp_options[i].split("_")[1]
          });
        }
      }
    }

    inputRef.current.value = value.label;
    setfilteredOptions(a);
    setselectedOption(val);
  };

  const refDropdown = (0, _react.useRef)();
  (0, _useOnClickOutside.default)(refDropdown, () => {
    setshowDropdown(false);
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    ref: refDropdown,
    className: "".concat(_DropdownlistModule.default.dropdownlist),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "".concat(_DropdownlistModule.default.input, "\n                ").concat(size === "mini" ? _DropdownlistModule.default.dropdownlist_mini : size === "compact" ? _DropdownlistModule.default.dropdownlist_compact : size === "default" ? _DropdownlistModule.default.dropdownlist_default : size === "large" ? _DropdownlistModule.default.dropdownlist_large : _DropdownlistModule.default.dropdownlist_default, "\n                ").concat(error && _DropdownlistModule.default.dropdownlist_error, "\n            "),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
        disabled: disabled,
        readOnly: readOnly,
        ref: inputRef,
        onFocus: () => {
          setshowDropdown(true);
        },
        onBlur: e => {
          if (selectedOption.split("_")[1]) {
            e.currentTarget.value = selectedOption.split("_")[1];
          }
        },
        onChange: e => {
          searchValues(e.currentTarget.value);
        },
        defaultValue: selectedOption.split("_")[1] || "",
        type: "text",
        placeholder: placeholder
      }), isClearable && /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        onClick: () => {
          selectValue("");
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
          className: _DropdownlistModule.default.icon,
          viewBox: "0 0 24 24",
          width: "24",
          height: "24",
          stroke: "currentColor",
          strokeWidth: "2",
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
            x1: "18",
            y1: "6",
            x2: "6",
            y2: "18"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
            x1: "6",
            y1: "6",
            x2: "18",
            y2: "18"
          })]
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        onClick: () => {
          inputRef.current.focus();
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
          className: _DropdownlistModule.default.icon,
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "black",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("polyline", {
            points: "6 9 12 15 18 9"
          })
        })
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      ref: refList,
      className: "".concat(!showDropdown ? _DropdownlistModule.default.hide_options : '', " ").concat(_DropdownlistModule.default.options, " ").concat(direction === "top" && _DropdownlistModule.default.options_top),
      children: filteredOptions.map((option, index) => {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
          id: uniqueId + "_" + option.value + "_" + option.label,
          onClick: () => {
            selectValue(option);
          },
          className: _DropdownlistModule.default.option,
          children: option.label
        }, index);
      })
    })]
  });
} // import { useEffect, useState, useRef } from "react";
// import styles from "../../assets/styles/components/Dropdownlist.module.scss";
// export default function Dropdownlist({options, selected, isSearchable, placeholder="Select...", onSelect, type}){
//     const [selectedOption, setselectedOption] = useState("");
//     const [filteredOptions, setfilteredOptions] = useState([]);
//     const [showDropdown, setshowDropdown] = useState(false);
//     useEffect(()=>{
//         if(Array.isArray(options)){
//             calculateOptions();
//         }
//     }, [options])
//     useEffect(()=>{
//         if(typeof(selected) === "string"){
//             calculateSelectedOption()
//         }
//     }, [selected])
//     const calculateSelectedOption = () => {
//         if(Array.isArray(options)){
//             if(options.includes(selected)){
//                 setselectedOption(selected);
//             }
//         }
//     }
//     const calculateOptions = () => {
//         if(type === "ID_LABEL"){
//             let a = []
//             let tmp_options = [...options]
//             for (let i = 0; i < tmp_options.length; i++) {
//                 tmp_options[i] = tmp_options[i].toString();
//                 if(tmp_options[i].split("_")[1]){
//                     if(selected !== tmp_options[i]){
//                         a.push({value: tmp_options[i].split("_")[0], label: tmp_options[i].split("_")[1]})
//                     }
//                 }
//             }
//             setfilteredOptions(a)
//         }
//     }
//     const searchValues = (value) => {
//         let tmp_options = [...options]
//         let a = []
//         for (let i = 0; i < tmp_options.length; i++) {
//             if(tmp_options[i].toString().toLowerCase().includes(value.toLowerCase())){
//                 if(tmp_options[i].split("_")[1]){
//                     if(selectedOption !== tmp_options[i]){
//                         a.push({value: tmp_options[i].split("_")[0], label: tmp_options[i].split("_")[1]})
//                     }
//                 }
//             }
//         }
//         setfilteredOptions(a);
//     }
//     const inputRef = useRef(null)
//     const selectValue = (value) => {
//         onSelect(value);
//         const val = value.value+"_"+value.label;
//         let a = []
//         let tmp_options = [...options]
//         for (let i = 0; i < tmp_options.length; i++) {
//             tmp_options[i] = tmp_options[i].toString();
//             if(tmp_options[i].split("_")[1]){
//                 if(val !== tmp_options[i]){
//                     a.push({value: tmp_options[i].split("_")[0], label: tmp_options[i].split("_")[1]})
//                 }
//             }
//         }
//         inputRef.current.value = value.label
//         setfilteredOptions(a)
//         setselectedOption(val)
//     }
//     return (
//         <div className={styles.dropdownlist}>
//             <div className={styles.input}>
//                 <input ref={inputRef} onFocus={()=>{setshowDropdown(true)}} onBlur={(e)=>{e.currentTarget.value = selectedOption.split("_")[1]; setshowDropdown(false)}} onChange={(e)=>{searchValues(e.currentTarget.value)}} defaultValue={selectedOption.split("_")[1] || ""} type="text" placeholder={placeholder}/>
//                 <button>
//                     <svg className={styles.icon} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>
//                 </button>
//             </div>
//             <div className={`${!showDropdown ? styles.hide_options : ''} ${styles.options}`}>
//                 {filteredOptions.map((option, index)=>{
//                     return (
//                         <button onClick={()=>{selectValue(option)}} className={styles.option} key={index}>{option.label}</button>
//                     )
//                 })}
//             </div>
//         </div>
//     )
// }